import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import {
  BETON_ORDER_CALCULATION,
  BETON_ORDER_CONFIRMATION,
  BETON_ORDER_INITIALIZATION,
  BetonState,
} from '../beton-state';
import { calculateOrderErrorReducer } from './beton-order-calc-error.reducer';
import { confirmOrderErrorReducer } from './beton-order-confirm-error.reducer';

export type BetonReducers = BetonState;

export function getReducers(): ActionReducerMap<BetonReducers> {
  return {
    initialData: StateUtils.loaderReducer(BETON_ORDER_INITIALIZATION),
    calculateOrder: StateUtils.loaderReducer(BETON_ORDER_CALCULATION),
    calculateOrderError: calculateOrderErrorReducer,
    confirmOrder: StateUtils.loaderReducer(BETON_ORDER_CONFIRMATION),
    confirmOrderError: confirmOrderErrorReducer,
  };
}
export const reducerToken: InjectionToken<ActionReducerMap<BetonReducers>> = new InjectionToken<
  ActionReducerMap<BetonReducers>
>('BetonReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
